import { motion, useReducedMotion } from 'framer-motion';

const base = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: 'false',
};

export const MailIcon = () => (
  <svg {...base}>
    <rect x="3" y="5" width="18" height="14" rx="3" />
    <path d="m4 7 8 6 8-6" />
  </svg>
);

export const KeyIcon = () => (
  <svg {...base}>
    <circle cx="8" cy="15" r="4" />
    <path d="m11 12 8-8m-3 3 2 2m-4 0 1.5 1.5" />
  </svg>
);

export const AlertIcon = () => (
  <svg {...base}>
    <path d="M12 4 2.8 19a1 1 0 0 0 .9 1.5h16.6a1 1 0 0 0 .9-1.5L12 4Z" />
    <path d="M12 10v4m0 3h.01" />
  </svg>
);

export const UserIcon = () => (
  <svg {...base}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c1.5-3.5 4.4-5 8-5s6.5 1.5 8 5" />
  </svg>
);

export const SmallCheckIcon = () => (
  <svg {...base} width={16} height={16} strokeWidth={2.2}>
    <path d="m5 12.5 4.2 4L19 7" />
  </svg>
);

export const LockIcon = () => (
  <svg {...base} width={14} height={14} strokeWidth={2}>
    <rect x="5" y="11" width="14" height="9" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);

// Draws itself in once: a circle, then the check.
export const AnimatedCheckIcon = () => {
  const reduceMotion = useReducedMotion();
  const draw = (delay) => (reduceMotion
    ? { initial: false }
    : {
      initial: { pathLength: 0, opacity: 0 },
      animate: { pathLength: 1, opacity: 1 },
      transition: { duration: 0.42, ease: [0.22, 1, 0.36, 1], delay },
    });

  return (
    <svg {...base} width={26} height={26} strokeWidth={2}>
      <motion.circle cx="12" cy="12" r="9" {...draw(0)} />
      <motion.path d="m7.8 12.4 2.8 2.8 5.6-5.8" {...draw(0.22)} />
    </svg>
  );
};
